import { EyeSlashIcon, LockIcon, PushPinIcon, TrashIcon, XIcon, FolderIcon } from "@phosphor-icons/react";
import { Button } from "@heroui/react";

import { ICON_SIZE } from "@/config/constants";
import { DrawerAndPopover } from "@/shared/components/common/DrawerAndPopover";
import { BULK_MOVE_NOTES_DRAWER_ID, BulkMoveNotesToFolderOption } from "../Note/BulkMoveNotesToFolderOption";

interface NotesSelectionToolbarProps {
  selectedNotesCount: number;
  selectedNoteIds: Set<number>;
  selectedFoldersCount?: number;
  selectedFolderIds?: Set<number>;
  currentFolderId?: number | null;
  onPinSelected: () => void;
  onLockSelected: () => void;
  onMaskSelected: () => void;
  onDeleteSelected: () => void;
  onClearSelection: () => void;
}

export function NotesSelectionToolbar({
  selectedNotesCount,
  selectedNoteIds,
  selectedFoldersCount = 0,
  selectedFolderIds = new Set(),
  currentFolderId,
  onPinSelected,
  onLockSelected,
  onMaskSelected,
  onDeleteSelected,
  onClearSelection,
}: NotesSelectionToolbarProps) {
  const totalSelectedCount = selectedNotesCount + selectedFoldersCount;
  if (totalSelectedCount === 0) return null;

  // Show only Delete and Move actions when folders are selected (with or without notes)
  const hasFoldersSelected = selectedFoldersCount > 0;

  if (hasFoldersSelected) {
    // When folders are selected, show limited actions (move and delete only)
    return [
      <DrawerAndPopover key="move-selected" id={BULK_MOVE_NOTES_DRAWER_ID} icon={<FolderIcon size={ICON_SIZE.md} />}>
        <BulkMoveNotesToFolderOption
          noteIds={selectedNoteIds}
          folderIds={selectedFolderIds}
          currentFolderId={currentFolderId}
          onClearSelection={onClearSelection}
        />
      </DrawerAndPopover>,
      <Button key="delete-selected" variant="light" isIconOnly onPress={onDeleteSelected}>
        <TrashIcon size={ICON_SIZE.md} />
      </Button>,
      <Button key="clear-selection" variant="light" isIconOnly onPress={onClearSelection}>
        <XIcon size={ICON_SIZE.md} />
      </Button>,
    ];
  }

  // Show all actions when only notes are selected (enhanced move component handles both notes and folders)
  return [
    <Button key="pin-selected" variant="light" isIconOnly onPress={onPinSelected}>
      <PushPinIcon size={ICON_SIZE.md} />
    </Button>,
    <Button key="lock-selected" variant="light" isIconOnly onPress={onLockSelected}>
      <LockIcon size={ICON_SIZE.md} />
    </Button>,
    <Button key="mask-selected" variant="light" isIconOnly onPress={onMaskSelected}>
      <EyeSlashIcon size={ICON_SIZE.md} />
    </Button>,
    <DrawerAndPopover key="move-selected" id={BULK_MOVE_NOTES_DRAWER_ID} icon={<FolderIcon size={ICON_SIZE.md} />}>
      <BulkMoveNotesToFolderOption
        noteIds={selectedNoteIds}
        folderIds={selectedFolderIds}
        currentFolderId={currentFolderId}
        onClearSelection={onClearSelection}
      />
    </DrawerAndPopover>,
    <Button key="delete-selected" variant="light" isIconOnly onPress={onDeleteSelected}>
      <TrashIcon size={ICON_SIZE.md} />
    </Button>,
    <Button key="clear-selection" variant="light" isIconOnly onPress={onClearSelection}>
      <XIcon size={ICON_SIZE.md} />
    </Button>,
  ];
}
